import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space, Typography } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminPurchasesTableColumns";
import moment from "moment-jalaali";


function AdminPurchasesListTable({
  data,
  onPageChange,
  currentPage,
  onSort,
  loading,
  onOpenDrawer,
}) {
  const [tableData, setTableData] = useState([]);
  const { getPurchasesCount: count, getPurchases: purchases } = data;

  useEffect(() => {
    const initialTableData = [];
    purchases.map((purchase) => {
      const {
        id,
        createdAt,
        updatedAt,
        amount,
        description,
        user
      } = purchase;
      initialTableData.push({
        key: id,
        updatedAt: moment(updatedAt).format("jYYYY/jMM/jDD"),
        createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
        amount:amount.toLocaleString(),
        description,
        payer: user?.name,
        details: (
          <Space>
            <a onClick={() => onOpenDrawer(id, user?.name)}>
              <EyeOutlined />
            </a>
          </Space>
        ),
      });
    });
    setTableData(initialTableData);
  }, [purchases]);

  const onChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableData}
            pagination={{
              total: count,
              current: currentPage,
              showSizeChanger: false,
            }}
            onChange={onChange}
            loading={loading}
            scroll={{ x:600 }}
          />
        </Col>
      </Row>
    </>
  );
}

export default AdminPurchasesListTable;
